import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Tabs, Tab } from "react-bootstrap";
import Swal from "sweetalert2";
import {
  exportarEvolucionesPDF,
  exportarMedicacionesPDF,
  exportarInsumosPDF,
  exportarSignosPDF,
} from "./pdfExporters";

import {
  getEvolucionesByPaciente,
  getMedicacionesbyPaciente,
  getInsumoUsadobyPaciente,
  getSignosVitalesbyPaciente,
} from "../../../api/EvolucionApi";

const ModalHojaEnfermeria = ({ estado, onCloseModal, idpaciente, nombrePaciente }) => {
  const [evoluciones, setEvoluciones] = useState([]);
  const [medicaciones, setMedicaciones] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [signos, setSignos] = useState([]);

  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [aplicarFiltro, setAplicarFiltro] = useState(false);

  // === Filtro por fecha ===
  const filtrarPorFecha = (lista) => {
    if (!aplicarFiltro || (!fechaInicio && !fechaFin)) return lista;

    return lista.filter((item) => {
      // Normalizar fecha del registro
      const fechaItem = new Date(item.fechahora);
      const itemDate = new Date(
        fechaItem.getFullYear(),
        fechaItem.getMonth(),
        fechaItem.getDate()
      );

      const inicio = fechaInicio ? new Date(fechaInicio + "T00:00:00") : null;
      const fin = fechaFin ? new Date(fechaFin + "T23:59:59") : null;

      if (inicio && itemDate < inicio) return false;
      if (fin && itemDate > fin) return false;
      return true;
    });
  };

  const evolucionesFiltradas = filtrarPorFecha(evoluciones);
  const medicacionesFiltradas = filtrarPorFecha(medicaciones);
  const insumosFiltrados = filtrarPorFecha(insumos);
  const signosFiltrados = filtrarPorFecha(signos);

  // === Cargar datos ===
  useEffect(() => {
    const fetchData = async () => {
      try {
        Swal.fire({
          title: "Cargando Hoja de Enfermería...",
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        const [ev, med, ins, sig] = await Promise.all([
          getEvolucionesByPaciente(idpaciente),
          getMedicacionesbyPaciente(idpaciente),
          getInsumoUsadobyPaciente(idpaciente),
          getSignosVitalesbyPaciente(idpaciente),
        ]);

        setEvoluciones(ev);
        setMedicaciones(med);
        setInsumos(ins);
        setSignos(sig);

        Swal.close();
      } catch (error) {
        Swal.fire("Error", error.message || "No se pudo cargar la hoja", "error");
      }
    };

    if (estado) fetchData();
  }, [estado, idpaciente]);

  return (
    <Modal show={estado} onHide={onCloseModal} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Hoja de Enfermería</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* === FILTROS === */}
        <div
          style={{
            display: "flex",
            gap: "15px",
            marginBottom: "15px",
            alignItems: "flex-end",
          }}
        >
          <div>
            <label>Desde:</label>
            <input
              type="date"
              className="form-control"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>
          <div>
            <label>Hasta:</label>
            <input
              type="date"
              className="form-control"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>

          <Button variant="success" onClick={() => setAplicarFiltro(true)}>
            Filtrar
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setFechaInicio("");
              setFechaFin("");
              setAplicarFiltro(false);
            }}
          >
            Limpiar
          </Button>
        </div>

        {/* === TABS === */}
        <Tabs defaultActiveKey="evoluciones" className="mb-3">
          {/* Evoluciones */}
          <Tab eventKey="evoluciones" title="Evoluciones">
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="primary"
                onClick={() =>
                  exportarEvolucionesPDF(evolucionesFiltradas, nombrePaciente)
                }
              >
                Descargar PDF
              </Button>
            </div>
            <Table bordered responsive>
              <tbody>
                {evolucionesFiltradas.map((e, idx) => (
                  <React.Fragment key={idx}>
                    <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                      <td>
                        <strong>Fecha/Hora:</strong> {e.fechahora} &nbsp; | &nbsp;
                        <strong>Usuario:</strong> {e.usuarioCreacion}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          fontSize: "15px",
                          padding: "12px",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          maxWidth: "900px",
                        }}
                      >
                        <div style={{ minHeight: "60px" }}>{e.texto}</div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Tab>

          {/* Medicaciones */}
          <Tab eventKey="medicaciones" title="Medicaciones">
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="primary"
                onClick={() =>
                  exportarMedicacionesPDF(medicacionesFiltradas, nombrePaciente)
                }
              >
                Descargar PDF
              </Button>
            </div>
            <Table bordered responsive>
              <tbody>
                {medicacionesFiltradas.map((m, idx) => (
                  <React.Fragment key={idx}>
                    <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                      <td>
                        <strong>Fecha/Hora:</strong> {m.fechahora} &nbsp; | &nbsp;
                        <strong>Usuario:</strong> {m.usuarioCreacion}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><strong>Medicacion:</strong> {m.medicacion}</p>
                        <p><strong>Dosis:</strong> {m.dosis}</p>
                        <p><strong>Médico:</strong> {m.medico}</p>
                        <p><strong>Registro:</strong> {m.registro}</p>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Tab>

          {/* Insumos */}
          <Tab eventKey="insumos" title="Insumos Usados">
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="primary"
                onClick={() => exportarInsumosPDF(insumosFiltrados, nombrePaciente)}
              >
                Descargar PDF
              </Button>
            </div>
            <Table bordered responsive>
              <tbody>
                {insumosFiltrados.map((i, idx) => (
                  <React.Fragment key={idx}>
                    <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                      <td>
                        <strong>Fecha/Hora:</strong> {i.fechahora} &nbsp; | &nbsp;
                        <strong>Usuario:</strong> {i.usuarioCreacion}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><strong>Insumo:</strong> {i.insumo}</p>
                        <p><strong>Cantidad:</strong> {i.cantidad}</p>
                        <p><strong>Tipo:</strong> {i.tipoinsumo}</p>
                        <p><strong>Encargado:</strong> {i.encargado}</p>
                        <p><strong>Observación:</strong> {i.obs}</p>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Tab>

          {/* Signos Vitales */}
          <Tab eventKey="signos" title="Signos Vitales">
            <div className="d-flex justify-content-end mb-2">
              <Button
                variant="primary"
                onClick={() => exportarSignosPDF(signosFiltrados, nombrePaciente)}
              >
                Descargar PDF
              </Button>
            </div>
            <Table bordered responsive>
              <tbody>
                {signosFiltrados.map((s, idx) => (
                  <React.Fragment key={idx}>
                    <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                      <td>
                        <strong>Fecha/Hora:</strong> {s.fechahora} &nbsp; | &nbsp;
                        <strong>Usuario:</strong> {s.usuariocreacion}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p><strong>Temp:</strong> {s.temperatura}</p>
                        <p><strong>SatO2:</strong> {s.sato2}</p>
                        <p><strong>FR:</strong> {s.fr}</p>
                        <p><strong>PA:</strong> {s.pa}</p>
                        <p><strong>FC:</strong> {s.fc}</p>
                        <p><strong>HGT:</strong> {s.hgt}</p>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHojaEnfermeria;
